import _ from 'lodash';


export const userNameRenderer = (text, record) => {
	const objectWithUserData = _.isObject(text) ? text : record;
	const firstName = _.get(objectWithUserData, 'firstName');
	const lastName = _.get(objectWithUserData, 'lastName');
	return firstName || lastName ? `${firstName || ''} ${lastName || ''}` : ''
};
